(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // ドロワーとカートページの両方に描画されるため、.cart-extra-fields 単位でスコープする
function initReceiptToggle() {
  document.querySelectorAll('.cart-extra-fields').forEach(function(wrap) {
    var receiptRadios = wrap.querySelectorAll('input[name="attributes[領収書]"]');
    var receiptNameField = wrap.querySelector('.receipt-name-field');

    if (!receiptRadios.length || !receiptNameField) return;

    function toggleReceiptName() {
      var checkedRadio = wrap.querySelector('input[name="attributes[領収書]"]:checked');

      if (checkedRadio && checkedRadio.value === '必要') {
        receiptNameField.style.display = 'block';
      } else {
        receiptNameField.style.display = 'none';
      }
    }

    receiptRadios.forEach(function(radio) {
      radio.onchange = toggleReceiptName;
    });

    toggleReceiptName();
  });
}

document.addEventListener('DOMContentLoaded', initReceiptToggle);
document.addEventListener('shopify:section:load', initReceiptToggle);

document.addEventListener('click', function() {
  setTimeout(initReceiptToggle, 300);
});
  } catch(e) { console.error(e); }
})();

})();
